export default "__VITE_ASSET__CA2XO6Wx__"